export default __webpack_public_path__ + "static/media/Jang Ssang Gum.ca65d6d5.jpg";